import React, { useEffect, useContext } from 'react';
import Link from 'next/link';
import { NextSeo } from 'next-seo';
import Prismic from 'prismic-javascript';
import { RichText, Date } from 'prismic-reactjs';
import { client } from '../prismic-configuration';
import Layout from '../components/Layout';
import BlogCard from '../components/Cards/BlogCard';
import Button from '../components/Buttons';
import { UIContext } from '../context/UIContext';
import { SEOInfo } from '../helpers/seo';

const Blog = (props) => {
    const { toggleStudioMenu } = useContext(UIContext);
    useEffect(() => {
        toggleStudioMenu(false);
    }, []);
    const { posts = [] } = props;
    return (
        <>
            <NextSeo
                title="Otellu || Where scaling your team starts"
                description="The job board for start- and scale-ups for finding young urban talent. Match further than just hard skills and find the perfect candidate with our features."
                openGraph={{
                    url: 'https://otellu.work/business',
                    title: 'Otellu - Where scaling your team starts',
                    description:
                        "Behind the scenes with Otellu's founders and employees. Follow our journey to become the number one platform for innovative companies. Read our stories about AI, tech, product and start-ups.",
                    images: [
                        {
                            url: SEOInfo.image,
                        },
                    ],
                    site_name: SEOInfo.siteName,
                }}
                twitter={{
                    handle: '@handle',
                    site: '@site',
                    cardType: 'summary_large_image',
                }}
            />
            <Layout title="Blog" content={props.content} hideSearchModal>
                <div className="relative bg-gray-50 pt-16 pb-20 px-4 sm:px-6 lg:pt-24 lg:pb-28 lg:px-8">
                    <div className="absolute inset-0">
                        <div className="bg-white h-1/3 sm:h-2/3"></div>
                    </div>
                    <div className="relative max-w-7xl mx-auto">
                        <div className="text-center">
                            <h2 className="text-3xl tracking-tight font-extrabold text-gray-900 sm:text-5xl">Otellu blog</h2>
                            <p className="mt-3 max-w-4xl mx-auto text-xl text-gray-500 sm:mt-4">
                                Behind the scenes with Otellu's founders and employees. Follow our journey to become the number one platform for innovative
                                companies. Read our stories about AI, tech, product and start-ups.
                            </p>
                        </div>
                        <div className="mt-20 max-w-lg mx-auto grid gap-5 lg:grid-cols-3 lg:max-w-none">
                            {props.posts.results.map((post) => (
                                <Link href="/post/[uid]" as={`/post/${post.uid}`}>
                                    <div className="flex flex-col rounded-lg shadow-lg overflow-hidden cursor-pointer">
                                        <div className="flex-shrink-0">
                                            <img width="360" height="192" className="h-48 w-full object-cover" src={post.data.image.url} alt="" />
                                        </div>
                                        <div className="flex-1 bg-white p-6 flex flex-col justify-between">
                                            <div className="flex-1">
                                                <Link href="/post/[uid]" as={`/post/${post.uid}`}>
                                                    <>
                                                        <p className="text-xl font-semibold text-gray-900">{post.data.seo_title}</p>
                                                        <p className="mt-3 text-base text-gray-500">{RichText.render(post.data.description)}</p>
                                                    </>
                                                </Link>
                                                <div className="mt-4">
                                                    <Link href="/post/[uid]" as={`/post/${post.uid}`}>
                                                        <Button theme="btn btn-black" text="View" />
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            ))}
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    );
};

Blog.getInitialProps = async (context) => {
    const home = await client.getSingle('blog_home');
    const posts = await client.query(Prismic.Predicates.at('document.type', 'blog_post'), { orderings: '[my.post.date desc]', lang: 'en-US' });
    return { home, posts };
};

export default Blog;
